import { render, staticRenderFns } from "./CollectionsNotExists.vue?vue&type=template&id=177960e6&scoped=true&"
import script from "./CollectionsNotExists.vue?vue&type=script&lang=ts&"
export * from "./CollectionsNotExists.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsNotExists.vue?vue&type=style&index=0&id=177960e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177960e6",
  null
  
)

export default component.exports